import React from "react";

import { IconProps } from "fe-shared/src/types/common";

const RevertIcon = ({
  width = "24",
  height = "24",
  style,
  className,
  fillClassName,
  fillColor = "#63696F",
}: IconProps) => (
  <svg
    style={style}
    width={width}
    height={height}
    aria-hidden="true"
    viewBox="0 0 24 24"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill={fillColor!}
      className={fillClassName}
      d="M4.14407 12.0018C4.14407 6.95178 8.31407 2.86178 13.4041 3.00178C18.0941 3.13178 22.0141 7.05178 22.1441 11.7418C22.2841 16.8318 18.1941 21.0018 13.1441 21.0018C11.5341 21.0018 10.0341 20.5718 8.72407 19.8418C8.15407 19.5218 8.06407 18.7318 8.52407 18.2718C8.83407 17.9518 9.31407 17.8718 9.70407 18.0918C10.7241 18.6618 11.8941 19.0018 13.1441 19.0018C17.0441 19.0018 20.1941 15.8118 20.1441 11.9018C20.0941 8.18178 16.9641 5.05178 13.2441 5.00178C9.32407 4.95178 6.14407 8.10178 6.14407 12.0018H7.93407C8.38407 12.0018 8.60407 12.5418 8.29407 12.8518L5.50407 15.6418C5.30407 15.8418 4.99407 15.8418 4.79407 15.6418L2.00407 12.8518C1.68407 12.5418 1.90407 12.0018 2.35407 12.0018H4.14407ZM13.1441 10.0018C14.2441 10.0018 15.1441 10.9018 15.1441 12.0018C15.1441 13.1018 14.2441 14.0018 13.1441 14.0018C12.0441 14.0018 11.1441 13.1018 11.1441 12.0018C11.1441 10.9018 12.0441 10.0018 13.1441 10.0018Z"
    />
  </svg>
);

export default RevertIcon;
